// @flow
import React from 'react';
import { connect } from 'react-redux';
import { AddNode } from './AddNode';
import { LabelNode } from './LabelNode';
import { PushNode } from './PushNode';
import { DelayNode } from './DelayNode';
import { EventNode } from './EventNode';
import { NodeWrapper } from './NodeWrapper';
import {
  ENTRY_TYPE,
  DELAY_TYPE,
  EVENT_LISTENER_TYPE,
  MESSAGE_TYPE,
  EXIT_TYPE,
  ADD_NODE_TYPE,
  LABEL_NODE_TYPE
} from '../constants/ApiTypes';
import { getParentName } from '../util/TreeUtils';

import { selectNode as selectNodeAction } from '../actions/tree';

export type NodeType = {
  x: number,
  y: number,
  parent: {
    data: {
      parentName: string
    }
  },
  data: {
    id: number,
    node_type: typeof ADD_NODE_TYPE | 'empty_node' | typeof MESSAGE_TYPE,
    height: number,
    width: number,
    icon: string,
    parentName: string,
    next: string,
    nextKey: string,
    labelText: string,
    centerX: number,
    centerY: number,
    rx: number,
    ry: number,
    fillColor?: string,
    fill?: string,
    iconFill?: string,
    message_type: string,
    expiration_minutes: number,
    duration_minutes: number,
    selected: boolean,
    display_name: string,
    event_mapping_id: number,
    unit: string,
    name: string,
    creative_ids: Array<number>
  }
};

export type NodeProps = {
  dispatch: Function,
  node: NodeType,
  creativeData?: Object, // eslint-disable-line
  commonData: {
    versionsByOrchestrationId: Object,
    apps: Object
  },
  editable: boolean
};

function Node(props: NodeProps) {
  const selectNode = nodeName => props.dispatch(selectNodeAction(nodeName));
  const { node, editable } = props;
  const nodeWrapperProps = {
    x: node.x,
    y: node.y,
    height: node.data.height,
    width: node.data.width,
    rx: node.data.rx,
    ry: node.data.ry,
    fill: node.data.fill,
    selected: node.data.selected,
    selectNode,
    name: node.data.name,
    type: node.data.node_type
  };
  switch (node.data.node_type) {
    case ADD_NODE_TYPE: {
      const { data } = node;
      const addNodeProps = {
        parentName: getParentName(node),
        next: data.next,
        nextKey: data.nextKey,
        height: data.height,
        rx: data.rx,
        ry: data.ry,
        selected: data.selected,
        editable
      };
      return (
        <NodeWrapper {...nodeWrapperProps}>
          <AddNode {...addNodeProps} />
        </NodeWrapper>
      );
    }
    case LABEL_NODE_TYPE: {
      const { data: { labelText } } = node;
      return (
        <NodeWrapper {...nodeWrapperProps}>
          <LabelNode labelText={labelText} />
        </NodeWrapper>
      );
    }
    case MESSAGE_TYPE: {
      const { data } = node;
      const pushMessageProps = {
        message_type: data.message_type,
        creative_ids: data.creative_ids,
        display_name: data.display_name,
        name: data.name,
        selected: data.selected,
        height: data.height,
        rx: data.rx,
        ry: data.ry,
        editable
      };

      return (
        <NodeWrapper {...nodeWrapperProps}>
          <PushNode {...pushMessageProps} />
        </NodeWrapper>
      );
    }
    case ENTRY_TYPE:
    case EXIT_TYPE:
      return null;
    case DELAY_TYPE: {
      const { data } = node;

      const delayNodeProps = {
        duration_minutes: data.duration_minutes,
        unit: data.unit,
        height: data.height,
        rx: data.rx,
        ry: data.ry,
        selected: data.selected,
        parentName: getParentName(node),
        name: data.name,
        editable
      };
      return (
        <NodeWrapper {...nodeWrapperProps}>
          <DelayNode {...delayNodeProps} />
        </NodeWrapper>
      );
    }
    case EVENT_LISTENER_TYPE: {
      const { data } = node;
      const eventListenerNodeProps = {
        nodeId: data.id,
        expiration_minutes: data.expiration_minutes,
        unit: data.unit,
        selected: data.selected,
        display_name: data.display_name,
        height: data.height,
        rx: data.rx,
        ry: data.ry,
        event_mapping_id: data.event_mapping_id,
        parentName: getParentName(node),
        name: data.name,
        editable
      };
      return (
        <NodeWrapper {...nodeWrapperProps}>
          <EventNode {...eventListenerNodeProps} />
        </NodeWrapper>
      );
    }
    default:
      return <NodeWrapper {...nodeWrapperProps} />;
  }
}

export default connect()(Node);



// WEBPACK FOOTER //
// ./src/components/Node.jsx